import { render, staticRenderFns } from "./Genarate.vue?vue&type=template&id=d48e3ac0"
import script from "./Genarate.vue?vue&type=script&lang=js"
export * from "./Genarate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports